import { Box, Link } from '@ksyos/design-system';
import { useState } from 'react';
import { TherapielandSsoLink } from '../../../../elements/TherapielandSsoLink';
import { GgzbTherV1IndexListModal } from './GgzbTherV1IndexListModal';

export function GgzbTherV1ProgrammeLinks() {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Box
                alignItems="center"
                display="flex"
                flexWrap="wrap"
                mb={6}
            >
                <TherapielandSsoLink isToProgramOverview={true}>
                    Bekijk programma&apos;s in Therapieland
                </TherapielandSsoLink>
                <Link
                    iconLeft="jobs"
                    ml={4}
                    onClick={() => setShowModal(!showModal)}
                    variant="button"
                >
                    Inhoudsopgave
                </Link>
            </Box>
            <GgzbTherV1IndexListModal
                setShowModal={setShowModal}
                showModal={showModal}
            />
        </>
    );
}
